import { render, staticRenderFns } from "./j-list.vue?vue&type=template&id=0fe16d4c&scoped=true&"
import script from "./j-list.vue?vue&type=script&lang=js&"
export * from "./j-list.vue?vue&type=script&lang=js&"
import style0 from "./j-list.vue?vue&type=style&index=0&id=0fe16d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe16d4c",
  null
  
)

export default component.exports